import { getIsFirstTimeUser } from '@helpers/session/user'
import { analytics } from '@helpers/analytics'
import { getValueFromObject } from '@helpers/utils'
import { Cards, ContentFulPageProps } from './types'
import dynamic from 'next/dynamic'

const FeatureCardsWrapper = dynamic(() => import('./FeatureCardsWrapper'), {
  ssr: false
})

function getPageData(props: ContentFulPageProps) {
  const cards: Cards = [
    {
      id: 0,
      title: props?.title1,
      copy: props?.copy1,
      media: {
        title: getValueFromObject(props, 'media1.title', undefined),
        file: getValueFromObject(props, 'media1.file', undefined),
        description: getValueFromObject(props, 'media1.description', undefined)
      },
      images: {
        desktopLarge: props.imageDesktopLarge1,
        desktop: props.imageDesktop1,
        mobile: props.imageMobile1
      },
      thumbnail: {
        event: {
          action: `${props?.title2} Icon`
        },
        label: props?.thumbnailLabel1
      },
      visibility: getValueFromObject(props, 'visibility1', false),
      theme: getValueFromObject(props, 'theme1', 'dark-theme')
    },
    {
      id: 1,
      title: props?.title2,
      copy: props?.copy2,
      media: {
        title: getValueFromObject(props, 'media2.title', undefined),
        file: getValueFromObject(props, 'media2.file', undefined),
        description: getValueFromObject(props, 'media2.description', undefined)
      },
      images: {
        desktopLarge: props.imageDesktopLarge2,
        desktop: props.imageDesktop2,
        mobile: props.imageMobile2
      },
      thumbnail: {
        event: {
          action: `${props?.title2} Icon`
        },
        label: props?.thumbnailLabel2
      },
      visibility: getValueFromObject(props, 'visibility2', false),
      theme: getValueFromObject(props, 'theme2', 'dark-theme')
    },
    {
      id: 2,
      title: props?.title3,
      copy: props?.copy3,
      media: {
        title: getValueFromObject(props, 'media3.title', undefined),
        file: getValueFromObject(props, 'media3.file', undefined),
        description: getValueFromObject(props, 'media3.description', undefined)
      },
      images: {
        desktopLarge: props.imageDesktopLarge3,
        desktop: props.imageDesktop3,
        mobile: props.imageMobile3
      },
      thumbnail: {
        event: {
          action: `${props?.title2} Icon`
        },
        label: props?.thumbnailLabel3
      },
      visibility: getValueFromObject(props, 'visibility3', false),
      theme: getValueFromObject(props, 'theme3', 'dark-theme')
    }
  ].filter(card => card.visibility)

  return {
    copyAlignment: props?.copyAlignment,
    cards
  }
}

export default function FeatureCards(props: ContentFulPageProps) {
  const { cards, copyAlignment } = getPageData(props)

  const handleCallOutClick = () => {
    const firstTimeUser = getIsFirstTimeUser()

    analytics('Click', {
      category: props.pageType,
      label: 'Feature Card',
      type: firstTimeUser ? 'new' : 'existing'
    })
  }

  return (
    <>
      <FeatureCardsWrapper
        cards={cards}
        copyAlignment={copyAlignment}
        onTabClick={handleCallOutClick}
      />
    </>
  )
}
